// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__1vp6b","loading":"Loading_loading__39Qjr"};